import { Button, FormControl, Grid, IconButton, InputLabel, ListItemText, MenuItem, Paper, Select, TextField, InputAdornment, Autocomplete, createFilterOptions, CircularProgress, Tooltip, FormControlLabel, Checkbox } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { DeleteIcon } from '../Common/TableUI';
import { useDispatch } from 'react-redux';
import { addNewClientAsset, deleteClientAsset, getAllComponents, getAllFacilities, getClientAssetById, getClientLocations, getMidsByFacilityId, setStoreData, updateClientAsset, deleteClientAssetMedia, deleteClientAssets, deleteAllFacilityAssets, getFacilityAssetsById, getAllAssetNames } from '../../Redux/actions';
import dayjs from 'dayjs';
import AlertDialog from '../Common/AlertDialog';
import moment from 'moment';
import ConfirmDialog from '../Common/ConfirmDialog';
import { isValidDate } from '../../utils/Common';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import CloseIcon from '@mui/icons-material/Close';
import Loader from '../Common/Loader';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import { buttonStyles, checkboxStyle, inputLabelFocusedStyle, selectFocusedStyle } from '../../theme/formStyles';

export default function ManageClientAsset () {

    const location = useLocation();
    const locationState = location?.state;

    let { facilityId: id, client_id: client_id, tabId } = useParams()
    let navigate = useNavigate()
    const dispatch = useDispatch();

    const assetCategories = [ 'Sale', 'Treatment', 'Distribution', 'Leased Asset' ]

    const [sharedFields, setSharedFields] = useState({
        category: '',
        facility: '',
    });

    const [assetEntries, setAssetEntries] = useState([
        {
            assetId: '',
            assetName: '',
            serialNumber: '',
            componentId: '',
            rating: '',
            unitPrice: '',
            cost: '',
            particulars: '',
            coordinates: '',
            purchaseDate:'',
            endOfWarrantyDate:'',
            installationDate:'',
            operationStartDate:'',
            operationEndDate:'',
            endOfLifeDate:'',
            images: [],
            inactive: '',
        }
    ]);
    const [facilities, setFacilities] = useState(null)
    const [componentIds, setComponentIds] = useState(null)
    const [locationData, setLocationData] = useState(null);
    const [facilityName, setFacilityName] = useState('')
    const [alertMessage, setAlertMessage] = useState();
    const [msgType, setMsgType] = useState("success");
    const [itemNotFound, setItemNotFound] = useState(false);
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const error = {};
    const [errors, setErrors] = useState(error);
    const [disableButton, setDisableButton] = useState(false);
    const [meterData, setMeterData] = useState([])
    const [selectedMeterIds, setSelectedMeterIds] = useState({});
    const [showLoader, setShowLoader] = useState( id ? true : false )
    const [uploadedFile, setUploadedFile] = useState([]);
    const [selectedFile, setSelectedFile] = useState([]);
    const [showConfirmUploadDialog, setShowConfirmUploadDialog] = useState(false);
    const [uploadedImage, setUploadedImage] = useState();
    const [deletedItem, setDeletedItem] = useState([]);
    const [deletedImages, setDeletedImages] = useState([]);
    const [deletedAssets, setDeletedAssets] = useState([]);
    const [clickSubmitButton, setClickSubmitButton] = useState(false);
    const [geoError, setGeoError] = useState('');
    const [assetNames, setAssetNames] = useState([]);

    const clientAssetQueryParams = localStorage.getItem("clientAssetQueryParams");
    const clientAssetTabId = localStorage.getItem("clientAssetTabId");

    useEffect(() => {
        dispatch(getAllFacilities(client_id)).then((res) => {
            if (res && res.status === 200) {
                setFacilities(res.data.data)
            }
        });
        dispatch(getAllComponents()).then((res) => {
            if (res && res.status === 200) {
                const componentsWithMaintnceSchdle = res?.data?.allData?.filter(item => item?.compMaintenanceSchedules?.length > 0 )
                setComponentIds(componentsWithMaintnceSchdle)
            }
        });
        dispatch(getAllAssetNames()).then((res) =>{
            if (res && res.status === 200) {
                setAssetNames(
                    res?.data?.assetNames?.map(item => ({
                      id: item?.id,
                      asset_name: item?.asset_name
                    }))
                );
            }
        })
    },[])

    useEffect(() => {
        if (id) {
            dispatch(getFacilityAssetsById(client_id, id, tabId, { filterInactive: false })).then((resp) => {
                const response = resp?.data?.assetData
                if (!response) {
                    setItemNotFound(true);
                    setShowLoader(false)
                    return;
                }

                const { category, facility_id } = response[0];
                setSharedFields({
                    category,
                    facility: facility_id
                });
                
                if (facility_id) {
                    fetchAssetMids(facility_id);
                }

                const assetsToSet = []; 
                const meterMap = {};

                for (const [index, asset] of response.entries()) {
                    const {
                        name, component_id, serial_number,
                        purchase_date, installation_date, operation_start_date,
                        maintenance_date, operation_end_date, end_of_life_date,
                        rating, unit_price, cost, bill_number,
                        vendor_name, warranty_end_date, assetMedia,
                        geo_proof_lat, geo_proof_lon, unique_id, assetMeter, inactive
                    } = asset;
                    
                    const mappedMedia = assetMedia?.map((mediaItem) => ({
                        uid: mediaItem.id,
                        url: mediaItem.path,
                        name: mediaItem.name || 'Asset Image',
                        type: mediaItem.type
                    })) || [];

                    assetsToSet.push({
                        assetId: unique_id,
                        assetName: name,
                        componentId: component_id,
                        serialNumber: serial_number,
                        particulars: asset.particulars,
                        rating: rating,
                        unitPrice: unit_price,
                        cost: cost,
                        vendorName: vendor_name,
                        billNumber: bill_number,
                        coordinates: (geo_proof_lat && geo_proof_lon) ? `${geo_proof_lat}, ${geo_proof_lon}` : '',
                        purchaseDate: purchase_date ? moment(purchase_date).toISOString() : '',
                        installationDate: installation_date ? moment(installation_date).toISOString() : '',
                        operationStartDate: operation_start_date ? moment(operation_start_date).toISOString() : '',
                        maintenanceDate: maintenance_date ? moment(maintenance_date).toISOString() : '',
                        operationEndDate: operation_end_date ? moment(operation_end_date).toISOString() : '',
                        endOfLifeDate: end_of_life_date ? moment(end_of_life_date).toISOString() : '',
                        endOfWarrantyDate: warranty_end_date ? moment(warranty_end_date).toISOString() : '',
                        images: mappedMedia,
                        inactive: inactive === 'true'
                    });

                    if (assetMeter?.meter) {
                        meterMap[index] = assetMeter?.meter;
                    }
                }
                setSelectedMeterIds(meterMap);
                setAssetEntries(assetsToSet);
                setShowLoader(false);
            })
        }
    }, []);

    useEffect(()=>{
        if ( sharedFields.facility ) {
            const selectedFacility = facilities?.find((fItem => fItem?.id === sharedFields.facility))
            const location = selectedFacility?.location?.name
            setLocationData(location)
        }
    },[sharedFields.facility, facilities])

    const fetchAssetMids = (facility) => {
        dispatch(getMidsByFacilityId(client_id, facility)).then((resp) => {
            setMeterData(resp?.data?.midData)

        })
    }

    const handleSharedChange = (field, value) => {
        if ( field === 'facility' ) {
            setSelectedMeterIds({})
            fetchAssetMids(value)
        }
        setSharedFields(prev => ({ ...prev, [field]: value }));

        if (errors[field]) {
            setErrors((prevErrors) => {
                const newErrors = { ...prevErrors };
                delete newErrors[field];
                return newErrors;
            });
        }

        if (disableButton) {
            setDisableButton(false)
        }
    };

    const handleInactiveStatus = (index, e) => {
        const { checked } = e.target;
        const updatedAssets = [...assetEntries];
        updatedAssets[index]['inactive'] = checked;
        setAssetEntries(updatedAssets);

        if(disableButton){
            setDisableButton(false)
        }
    }

    const handleAssetChange = (index, field, value) => {

        if (field === 'cost' || field === 'rating' || field === 'unitPrice') {
            const isValid = /^[0-9]*\.?[0-9]*$/.test(value);
            if (!isValid) {
                return;
            }
        }
        
        const updatedAssets = [...assetEntries];
        updatedAssets[index][field] = value;
        setAssetEntries(updatedAssets);

        const errorKey = `asset_${index}_${field}`;
        if (errors[errorKey]) {
            setErrors((prevErrors) => {
                const newErrors = { ...prevErrors };
                delete newErrors[errorKey];
                return newErrors;
            });
        }

        if (disableButton) {
            setDisableButton(false)
        }
    };

    const handleMeterChange = (index, event,value) => { 
        setSelectedMeterIds(prev => ({ ...prev, [index]: value }));
        if (disableButton) {
            setDisableButton(false)
        }
        const errKey = `asset_${index}_selectedMeterId`;
        if (errors[errKey]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[errKey];
                return newErrors;
            });
        }
    }

    const getCurrentLocation = (index) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    const coords = `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
                    handleAssetChange(index, 'coordinates', coords);
                },
                (error) => {
                    console.error("Error fetching location: ", error);
                    setGeoError(error.message || "Failed to fetch location");
                }
            );
        } else {
            console.error("Geolocation not supported by this browser.");
            setGeoError("Geolocation is not supported by this browser.");
        }
    };    

    const updateResponse = (resp, message) => {
        const res = resp && resp.data;
        let msg = res.message;
        let type = "fail";
        if (res && res.success) {
            msg = message;
            type = "success";
        }
        dispatch(setStoreData('alertMessage', {
            msg, type,
            handleClose: () => handleCloseDialog(),
        }))
    };

    const handleCloseDialog = () => {
        dispatch(setStoreData('alertMessage', null));
        if ( clientAssetQueryParams ) {
            navigate( `/client/${client_id}/client-assets/${sharedFields.category.toLowerCase().replace(/\s+/g, '-')}?${clientAssetQueryParams?.toString()}`)
        } else {
            navigate(`/client/${client_id}/client-assets/${sharedFields.category.toLowerCase().replace(/\s+/g, '-')}`)
        }
    };

    const getComparableDate = (date) => {
        if (!date) return null;
        return dayjs.isDayjs(date) ? date.toDate() : new Date(date);
    };

    const validateData = () => {
        let hasErrors = false;
        const err = {};
    
        if (!sharedFields.category) {
            hasErrors = true;
            err.category = 'Category is required';
        }
    
        if (!sharedFields.facility) {
            hasErrors = true;
            err.facility = 'Facility is required';
        }
    
        assetEntries.forEach((asset, index) => {
            const fieldPrefix = `asset_${index}_`;

            const purchaseDate = getComparableDate(asset?.purchaseDate);
            const installationDate = getComparableDate(asset?.installationDate);
            
            
            if (!asset.assetName || asset.assetName.trim() === '') {
                hasErrors = true;
                err[`${fieldPrefix}assetName`] = 'Item name is required';
            }
    
            if (!asset.serialNumber || asset.serialNumber.trim() === '') {
                hasErrors = true;
                err[`${fieldPrefix}serialNumber`] = 'Serial number is required';
            }
    
            if (!asset.cost || asset.cost.trim() === '') {
                hasErrors = true;
                err[`${fieldPrefix}cost`] = 'Asset cost is required';
            }
    
            if (!asset.particulars || asset.particulars.trim() === '') {
                hasErrors = true;
                err[`${fieldPrefix}particulars`] = 'Particulars are required';
            }
    
            if (!asset.purchaseDate) {
                hasErrors = true;
                err[`${fieldPrefix}purchaseDate`] = 'Purchase date is required';
            }
            if ( asset.purchaseDate > new Date()) {
                hasErrors = true;
                err[`${fieldPrefix}purchaseDate`] = 'Future date cannot be selected';
            }
            if (asset.purchaseDate && !isValidDate(asset.purchaseDate)) {
                hasErrors = true;
                err[`${fieldPrefix}purchaseDate`] = 'Please enter a valid date in the format DD/MM/YYYY';
            }
    
            if (!asset.installationDate) {
                hasErrors = true;
                err[`${fieldPrefix}installationDate`] = 'Installation date is required';
            }
            if ( sharedFields?.category !== "Sale" && asset.installationDate > new Date() ) {
                hasErrors = true;
                err[`${fieldPrefix}installationDate`] = 'Future date cannot be selected';
            }
            if (asset.installationDate && !isValidDate(asset.installationDate)) {
                hasErrors = true;
                err[`${fieldPrefix}installationDate`] = 'Please enter a valid date in the format DD/MM/YYYY';
            }

            if ( (asset.installationDate && asset.purchaseDate) && (installationDate < purchaseDate) ){
                hasErrors = true;
                err[`${fieldPrefix}installationDate`] = 'Installation date cannot be less than Purchase date'
            }
    
            if (sharedFields.category === 'Treatment' || sharedFields.category === 'Distribution') {

                const operationStartDate = getComparableDate(asset?.operationStartDate);
                const operationEndDate = getComparableDate(asset?.operationEndDate);
                const endOfLifeDate = getComparableDate(asset?.endOfLifeDate);

                if (!asset.componentId || asset.componentId.trim() === '') {
                    hasErrors = true;
                    err[`${fieldPrefix}componentId`] = 'Component ID is required';
                }
                if (!asset.rating) {
                    hasErrors = true;
                    err[`${fieldPrefix}rating`] = 'Rating is required';
                }
                if (!asset.unitPrice) {
                    hasErrors = true;
                    err[`${fieldPrefix}unitPrice`] = 'Unit price is required';
                }
                if (!asset.operationStartDate) {
                    hasErrors = true;
                    err[`${fieldPrefix}operationStartDate`] = 'Operation start date is required';
                }
                if ( asset.operationStartDate > new Date()){
                    hasErrors = true;
                    err[`${fieldPrefix}operationStartDate`] = 'Future date cannot be selected';
                }
                if (asset.operationStartDate && !isValidDate(asset.operationStartDate)) {
                    hasErrors = true;
                    err[`${fieldPrefix}operationStartDate`] = 'Please enter a valid date in the format DD/MM/YYYY';
                }
                if ( asset.operationEndDate > new Date()){
                    hasErrors = true;
                    err[`${fieldPrefix}operationEndDate`] = 'Future date cannot be selected';
                }
                if (asset.operationEndDate && !isValidDate(asset.operationEndDate)) {
                    hasErrors = true;
                    err[`${fieldPrefix}operationEndDate`] = 'Please enter a valid date in the format DD/MM/YYYY';
                }
                if ( asset.endOfLifeDate > new Date()){
                    hasErrors = true;
                    err[`${fieldPrefix}endOfLifeDate`] = 'Future date cannot be selected';
                }
                if (asset.endOfLifeDate && !isValidDate(asset.endOfLifeDate)) {
                    hasErrors = true;
                    err[`${fieldPrefix}endOfLifeDate`] = 'Please enter a valid date in the format DD/MM/YYYY';
                }
                if ( (asset.operationStartDate && asset.installationDate) && (operationStartDate < installationDate) ) {
                    hasErrors = true;
                    err[`${fieldPrefix}operationStartDate`] = 'Operation start date cannot be less than Installation date'
                }
                if ( (asset.operationEndDate && asset.operationStartDate) && ( operationEndDate < operationStartDate) ) {
                    hasErrors = true;
                    err[`${fieldPrefix}operationEndDate`] = 'Operation end date cannot be less than Operation start date'
                }
                if ( (asset.operationEndDate && asset.endOfLifeDate) && (endOfLifeDate < operationEndDate) ) {
                    hasErrors = true;
                    err[`${fieldPrefix}endOfLifeDate`] = 'End of life date cannot be less than Operation end date'
                }
            }

            if (
                (sharedFields?.category === 'Treatment' || sharedFields?.category === 'Distribution') &&
                (!selectedMeterIds?.[index] || Object.keys(selectedMeterIds?.[index] || {}).length === 0)
            ) {
                hasErrors = true;
                err[`${fieldPrefix}selectedMeterId`] = 'Meter is required';
            }
    
            if (asset.coordinates) {
                const coordinatePattern = /^-?\d{1,2}(\.\d+)?,\s?-?\d{1,3}(\.\d+)?$/;
                if (!coordinatePattern.test(asset.coordinates)) {
                    hasErrors = true;
                    err[`${fieldPrefix}coordinates`] = 'Coordinates are invalid';
                }
            }

            if ( sharedFields.category === 'Leased Asset' || sharedFields.category === 'Sale') {
                const endOfWarrantyDate = getComparableDate( asset?.endOfWarrantyDate )
                if (asset.endOfWarrantyDate && !isValidDate(asset.endOfWarrantyDate)) {
                    hasErrors = true;
                    err[`${fieldPrefix}endOfWarrantyDate`] = 'Please enter a valid date in the format DD/MM/YYYY';
                }
                if ( (asset.endOfWarrantyDate && asset.purchaseDate) && (endOfWarrantyDate < purchaseDate) ) {
                    hasErrors = true;
                    err[`${fieldPrefix}endOfWarrantyDate`] = 'End of warranty date cannot be less than purchase date';
                }
            }
    
            
        });
    
        setErrors(err);
        return !hasErrors;
    };
    
    const handleSubmit = async () => {
        setDisableButton(true);
        const checkForm = validateData();

        if ( checkForm ) {
            setClickSubmitButton(true)
            const payload = [];
            const allFiles = [];
        
            assetEntries.forEach((entry, index) => {
                let latitude = '';
                let longitude = '';
                if (entry?.coordinates) {
                    [latitude, longitude] = entry.coordinates.split(',').map(coord => coord.trim());
                }
        
                const assetData = {
                    assetId: entry?.assetId || null,
                    assetName: entry.assetName,
                    componentId: (sharedFields?.category === 'Treatment' || sharedFields.category === 'Distribution') ? entry.componentId : null,
                    category: sharedFields.category,
                    serialNumber: entry.serialNumber,
                    client_id,
                    facility: sharedFields.facility,
                    meterAddress: entry.meterAddress,
                    particulars: entry.particulars,
                    purchaseDate: entry.purchaseDate,
                    installationDate: entry.installationDate,
                    operationStartDate: (sharedFields?.category === 'Treatment' || sharedFields.category === 'Distribution') ? entry.operationStartDate : null,
                    maintenanceDate: entry.maintenanceDate,
                    operationEndDate: (sharedFields?.category === 'Treatment' || sharedFields.category === 'Distribution') ? entry.operationEndDate : null,
                    endOfLifeDate: (sharedFields?.category === 'Treatment' || sharedFields.category === 'Distribution') ? entry.endOfLifeDate : null,
                    latitude: latitude || '',
                    longitude: longitude || '',
                    selectedMeterId: selectedMeterIds?.[index],
                    rating: (sharedFields?.category === 'Treatment' || sharedFields.category === 'Distribution') ? entry.rating : null,
                    unitPrice: (sharedFields?.category === 'Treatment' || sharedFields.category === 'Distribution') ? entry.unitPrice : null,
                    cost: entry.cost,
                    billNumber: (sharedFields?.category === 'Leased Asset' || sharedFields?.category === 'Sale') ? entry.billNumber : null,
                    vendorName: (sharedFields?.category === 'Leased Asset' || sharedFields?.category === 'Sale') ? entry.vendorName : null,
                    endOfWarrantyDate: (sharedFields?.category === 'Leased Asset' || sharedFields?.category === 'Sale') ? entry.endOfWarrantyDate : null,
                    inactive: entry?.inactive === true ? true : false,
                    assetIndex: index,
                };
        
                payload.push(assetData);
        
                const uploadedFiles = (entry.images || []).map(img => img.originFileObj).filter(Boolean);
                uploadedFiles.forEach((file) => {
                    file.assetIndex = index;
                    allFiles.push(file);
                });
            });
            const formData = new FormData();
            formData.append('data', JSON.stringify(payload));
    
            if ( allFiles?.length > 0 ) {
                allFiles.forEach((file, fileIndex) => {
                    formData.append('imageFiles', file);
                    formData.append(`fileAssetIndex[${fileIndex}]`, file.assetIndex); 
                    formData.append('type', 'image');
                    formData.append('size', file.size);
                });
            }
            
            if (id) {
                dispatch(updateClientAsset(formData, id)).then((resp) => {
                    setDisableButton(false)
                    setClickSubmitButton(false)
                    if (!resp) {
                        return;
                    } else {
                        updateResponse(resp, resp?.data?.message);
                        if ( resp?.data?.success ){
                            if ( deletedAssets?.length > 0 ) {
                                dispatch(deleteClientAssets(client_id, deletedAssets)).then(res => { })
                            }
                            if (deletedImages?.length > 0) {
                                dispatch(deleteClientAssetMedia(deletedImages)).then(res => { })
                            }
                        }
                    }
                });
            } else {
                dispatch(addNewClientAsset(formData)).then((resp) => {
                    setDisableButton(false)
                    setClickSubmitButton(false)
                    if (!resp) {
                        return;
                    } else {
                        updateResponse(resp, resp?.data?.message);
                    }
                });
            }
        }
    };

    const handleImageUpload = (index, event) => {
        const files = Array.from(event.target.files);
        const newFiles = files.map((file, i) => {
            const customName = `asset_${index}_name_${file.name}`;
            
            const renamedFile = new File([file], customName, {
                type: file.type,
                lastModified: file.lastModified,
            });
    
            return {
                uid: `${Date.now()}-${i}`,
                name: customName,
                status: 'done',
                url: URL.createObjectURL(renamedFile),
                originFileObj: renamedFile,
            };
        });
    
        const updatedAssets = [...assetEntries];
        updatedAssets[index].images = [
            ...(updatedAssets[index].images || []),
            ...newFiles,
        ];
        setAssetEntries(updatedAssets);
    
        event.target.value = '';
    }; 

    const handleConfirmUpload = () => {
        const formData = new FormData();
        if (uploadedImage) {
            formData.append('imageFile', uploadedImage);
            formData.append('type', 'image');
            formData.append('size', uploadedImage?.size);
        }
        setShowConfirmUploadDialog(false)
    }

    const handleRemoveAssetEntry = (indexToRemove) => {
        setAssetEntries((prevEntries) => {
            const assetToRemove = prevEntries[indexToRemove];
    
            const removedImageUids = assetToRemove?.images?.map((img) => img.uid).filter(Boolean) || [];
            setDeletedImages((prev) => [...prev, ...removedImageUids]);

            const assetId = assetToRemove?.assetId;
            if (assetId) {
                setDeletedAssets((prev) => [...prev, assetId]);
            }
    
            return prevEntries.filter((_, index) => index !== indexToRemove);
        });

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            Object.keys(updatedErrors).forEach((key) => {
                if (key.startsWith(`asset_${indexToRemove}_`)) {
                    delete updatedErrors[key];
                }
            });
    
            const shiftedErrors = {};
            Object.keys(updatedErrors).forEach((key) => {
                const match = key.match(/^asset_(\d+)_/);
                if (match) {
                    const originalIndex = parseInt(match[1], 10);
                    if (originalIndex > indexToRemove) {
                        const newKey = key.replace(`asset_${originalIndex}_`, `asset_${originalIndex - 1}_`);
                        shiftedErrors[newKey] = updatedErrors[key];
                    } else {
                        shiftedErrors[key] = updatedErrors[key];
                    }
                } else {
                    shiftedErrors[key] = updatedErrors[key];
                }
            });
    
            return shiftedErrors;
        });

        if (disableButton) {
            setDisableButton(false);
        }
    };

    const handleImageDelete = (assetIndex, uid) => {
        const updatedAssets = [...assetEntries];
        updatedAssets[assetIndex].images = updatedAssets[assetIndex].images.filter(img => img.uid !== uid);
        setAssetEntries(updatedAssets);
        setDeletedImages((preItems) => [...preItems,uid])
    };

    const addAsset = () => {
        setAssetEntries(prev => ([
          ...prev,
          {
            assetName: '',
            serialNumber: '',
            componentId: '',
            rating: '',
            unitPrice: '',
            cost: '',
            particulars: '',
            coordinates: '',
            images: []
          }
        ]));
    };

    const triggerDelete = () => {
        setShowConfirmDialog(true);
    }

    const handleDeleteClientAsset = () => {
        setShowConfirmDialog(false);
        dispatch(deleteAllFacilityAssets(id, tabId)).then((resp) => {
            updateResponse(resp, resp?.data?.message);
        })
    }



    if (showLoader) {
        return <Grid container>
            <Grid style={{display: 'flex', justifyContent: 'center', width: '100vw', height: '500px',  alignItems: 'center' }}>
                <CircularProgress />
            </Grid>
        </Grid>
    }

    if (id && itemNotFound && !showLoader) {
        return <Grid container >
            <Grid item md={12} className='w3-padding' style={{ display: 'flex', justifyContent: 'center' }}>
                <h5 className='w3-text-grey'>
                    No Data Found
                </h5>
            </Grid>
        </Grid>
    }

    return (
        <Paper elevation={1} style={{ margin: '16px' }}>
            <Grid container className='w3-padding-small'>
                <Grid container >
                    <Grid item md={12} className='w3-padding' style={{ display: 'flex' }}>
                        {!id && (<IconButton
                            onClick={() => clientAssetQueryParams ? navigate(`/client/${client_id}/client-assets/${clientAssetTabId ? clientAssetTabId : tabId}?${clientAssetQueryParams?.toString()}`) : navigate(`/client/${client_id}/client-assets/${ clientAssetTabId ? clientAssetTabId : tabId}`)}
                            color="inherit">
                            <ArrowBackIosIcon fontSize='small'/>
                        </IconButton>)}
                        <h6>{id ? 'Edit Assets' : 'Add Assets'}</h6>
                    </Grid>
                    <Grid container item md={12} style={{ display: 'flex', flexDirection: 'row', }}>
                        <Grid container item md={12} className='w3-padding' style={{ alignContent: 'flex-start' }}>
                            <Grid item md={12} style={{ display: 'flex', flexDirection: 'row', }} className='w3-margin-bottom'>
                                <FormControl fullWidth required>
                                    <InputLabel sx={inputLabelFocusedStyle}>Category</InputLabel>
                                        <Select
                                        sx={selectFocusedStyle}
                                        label="Category"
                                        value={sharedFields.category}
                                        onChange={(e) => {
                                            handleSharedChange('category', e.target.value);
                                            setErrors({});
                                        }}
                                        MenuProps={{
                                            disableScrollLock: true,
                                        }}
                                        >
                                            {assetCategories.map((category, index) => (
                                                <MenuItem key={index} value={category}>
                                                    {category}
                                                </MenuItem>
                                            ))} 
                                        </Select>
                                </FormControl>
                            </Grid>
                            {errors.category && (
                            <div style={{ marginTop: '-12px' }} className='error-text w3-margin-bottom'>
                                {errors.category}
                            </div>
                            )}
                            <Grid container spacing={2}>
                                <Grid item md={6} style={{ display: 'flex', flexDirection: 'row', }} className='w3-margin-bottom'>
                                    <FormControl sx={{ width: '100%' }}>
                                        <InputLabel id="demo-multiple-name-label" sx={inputLabelFocusedStyle}>Facility *</InputLabel>
                                        <Select
                                            sx={selectFocusedStyle}
                                            fullWidth
                                            required
                                            value={sharedFields.facility}
                                            name="facility"
                                            label="Facility"
                                            onChange={(e) => handleSharedChange('facility', e.target.value)}
                                            renderValue={(selected) => {
                                                const selectedItem = facilities?.find(item => {
                                                    return item.id === selected
                                                });
                                                return (
                                                    <div>
                                                        {selectedItem?.facility_name ? selectedItem.facility_name : facilityName}
                                                    </div>
                                                );
                                            }}
                                            MenuProps={{
                                                disableScrollLock: true,
                                            }}
                                        >
                                            {facilities?.map(item => <MenuItem key={item.id} value={item.id}><ListItemText primary={item?.facility_name} /></MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item md={6} style={{ display: 'flex', flexDirection: 'row', }} className='w3-margin-bottom'>
                                    <TextField
                                        fullWidth
                                        label="Location"
                                        value={locationData}
                                        disabled={true}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item md={6}>
                                    {errors.facility && (
                                    <div style={{ marginTop: '-12px' }} className='error-text w3-margin-bottom'>
                                        {errors.facility}
                                    </div>
                                    )}
                                </Grid>
                                
                            </Grid>
                            <Grid item xs={12}>
                            {assetEntries.map((asset, index) => (
                            <>
                            <Paper
                                key={index}
                                elevation={4}
                                className="w3-padding w3-margin-bottom"
                            >
                            <Grid item md={12} style={{ display: 'flex', flexDirection: 'row', justifyContent:'space-between'}}>
                                <h6>Item #{index + 1}</h6>
                                {assetEntries?.length > 1 && (
                                    <Tooltip title="Remove" className='w3-right' style={{ position: 'absolute', top: '8px', right: '6px' }}>
                                        <Grid item style={{ display: 'flex', justifyContent: "flex-end" }} className="cursor-pointer font-size-12 error-text" onClick={() => handleRemoveAssetEntry(index)}>
                                            <CloseIcon name="remove" />
                                        </Grid>
                                    </Tooltip>
                                )}
                            </Grid>
                            <Grid item md={12} style={{ display: 'flex', flexDirection: 'row', }} className='w3-margin-bottom'>
                                <Autocomplete
                                fullWidth
                                    options={assetNames}
                                    filterSelectedOptions
                                    getOptionLabel={(option) => `${option?.asset_name}`}
                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                    renderInput={(params) => <TextField
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '&.Mui-focused fieldset': {
                                                    borderColor: '#008080',
                                                },
                                            },
                                            '& .MuiInputLabel-root.Mui-focused': {
                                                color: '#008080',
                                            },
                                        }} 
                                        {...params} label="Item Name*" />}
                                    onChange={(e, value) => handleAssetChange(index, 'assetName', value?.id || '')}
                                    value={assetNames.find((item) => item.id === asset.assetName) || null}
                                >
                                </Autocomplete>
                            </Grid>
                            {errors[`asset_${index}_assetName`] && (
                                <div
                                    style={{ marginTop: '-12px' }}
                                    className="error-text w3-margin-bottom"
                                >
                                    {errors[`asset_${index}_assetName`]}
                                </div>
                            )}
                            {(sharedFields?.category === 'Treatment' || sharedFields?.category === 'Distribution') && ( <Grid item md={12} style={{ display: 'flex', flexDirection: 'row', }} className='w3-margin-bottom'>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel id="demo-multiple-name-label" sx={inputLabelFocusedStyle}>Component ID *</InputLabel>
                                    <Select
                                        sx={selectFocusedStyle}
                                        fullWidth
                                        required
                                        value={asset.componentId}
                                        name="componentId"
                                        label="Component ID"
                                        onChange={(e) => handleAssetChange(index, 'componentId', e.target.value)}
                                        renderValue={(selected) => {
                                            const selectedItem = componentIds?.find(item => {
                                                return item.component_id === selected
                                            });
                                            return (
                                                <div>
                                                    {selectedItem?.component_id ? selectedItem.component_id : ''}
                                                </div>
                                            );
                                        }}
                                        MenuProps={{
                                            disableScrollLock: true,
                                        }}
                                    >
                                        {componentIds?.map(item => <MenuItem key={item.id} value={item.component_id}><ListItemText primary={item?.component_id} /></MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>)}
                            {errors[`asset_${index}_componentId`] && (
                                <div
                                    style={{ marginTop: '-12px' }}
                                    className="error-text w3-margin-bottom"
                                >
                                    {errors[`asset_${index}_componentId`]}
                                </div>
                            )}
                            <Grid item md={12} style={{ display: 'flex', flexDirection: 'row', }} className='w3-margin-bottom'>
                                <TextField
                                    fullWidth
                                    required
                                    label="Serial Number"
                                    value={asset.serialNumber}
                                    onChange={(e) => handleAssetChange(index, 'serialNumber', e.target.value)}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#008080',
                                            },
                                        },
                                        '& .MuiInputLabel-root.Mui-focused': {
                                            color: '#008080',
                                        },
                                    }}
                                />
                            </Grid>
                            {errors[`asset_${index}_serialNumber`] && (
                                <div
                                    style={{ marginTop: '-12px' }}
                                    className="error-text w3-margin-bottom"
                                >
                                    {errors[`asset_${index}_serialNumber`]}
                                </div>
                            )}
                            <Grid item md={6} style={{ display: 'flex', flexDirection: 'row' }} className='w3-margin-bottom'>
                                <Autocomplete
                                    fullWidth
                                    required={sharedFields?.category === 'Treatment' || sharedFields?.category === 'Distribution'}
                                    disabled={!sharedFields?.facility}
                                    options={meterData}
                                    filterSelectedOptions
                                    isOptionEqualToValue={(option,value) => option.mid === value.mid}
                                    getOptionLabel={(option) => `${option?.metername} - ${option?.meterid} (MID:${option?.mid})`}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                            <ListItemText primary={`${option?.metername} - ${option?.meterid} (MID:${option?.mid})`} />
                                        </li>
                                    )}

                                    value={meterData?.find((meter) => meter?.mid === selectedMeterIds?.[index]?.mid) || null}
                                    onChange={(e, value) => handleMeterChange(index, e, value)}
                                    renderInput={(params) => (
                                        <TextField
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: '#008080',
                                                    },
                                                },
                                                '& .MuiInputLabel-root.Mui-focused': {
                                                    color: '#008080',
                                                },
                                            }}
                                            {...params}
                                            label="Meter"
                                            name="meter_id"
                                            required={sharedFields?.category === 'Treatment' || sharedFields?.category === 'Distribution'}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item md={6}>
                                {errors[`asset_${index}_selectedMeterId`] && (
                                    <div style={{ marginTop: '-12px' }} className='error-text w3-margin-bottom'>
                                        {errors[`asset_${index}_selectedMeterId`]}
                                    </div>
                                )}
                            </Grid>
                            <Grid container spacing={2}>
                                {(sharedFields?.category === 'Treatment' || sharedFields?.category === 'Distribution') && (<Grid item md={4} style={{ display: 'flex', flexDirection: 'row', }} >
                                    <TextField
                                        fullWidth
                                        required
                                        label="Rating(KW)"
                                        value={asset.rating}
                                        onChange={(e) => handleAssetChange(index, 'rating', e.target.value)}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '&.Mui-focused fieldset': {
                                                    borderColor: '#008080',
                                                },
                                            },
                                            '& .MuiInputLabel-root.Mui-focused': {
                                                color: '#008080',
                                            },
                                        }}
                                    />
                                </Grid>)}
                                {(sharedFields?.category === 'Treatment' || sharedFields?.category === 'Distribution') && (<Grid item md={4} style={{ display: 'flex', flexDirection: 'row', }} >
                                    <TextField
                                        fullWidth
                                        required
                                        label="Unit Price(₹)"
                                        value={asset.unitPrice}
                                        onChange={(e) => handleAssetChange(index, 'unitPrice', e.target.value)}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '&.Mui-focused fieldset': {
                                                    borderColor: '#008080',
                                                },
                                            },
                                            '& .MuiInputLabel-root.Mui-focused': {
                                                color: '#008080',
                                            },
                                        }}
                                    />
                                </Grid>)}
                                <Grid item md={4} style={{ display: 'flex', flexDirection: 'row', }} >
                                    <TextField
                                        fullWidth
                                        required
                                        label="Asset Cost(₹)"
                                        value={asset.cost}
                                        onChange={(e) => handleAssetChange(index, 'cost', e.target.value)}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '&.Mui-focused fieldset': {
                                                    borderColor: '#008080',
                                                },
                                            },
                                            '& .MuiInputLabel-root.Mui-focused': {
                                                color: '#008080',
                                            },
                                        }}
                                    />
                                </Grid>
                                {(sharedFields?.category === 'Leased Asset' || sharedFields?.category === 'Sale') && (<Grid item md={4} style={{ display: 'flex', flexDirection: 'row', }} >
                                    <TextField
                                        fullWidth
                                        label="Bill Number"
                                        value={asset.billNumber || ''}
                                        onChange={(e) => handleAssetChange(index, 'billNumber', e.target.value)}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '&.Mui-focused fieldset': {
                                                    borderColor: '#008080',
                                                },
                                            },
                                            '& .MuiInputLabel-root.Mui-focused': {
                                                color: '#008080',
                                            },
                                        }}
                                    />
                                </Grid>)}
                                {(sharedFields?.category === 'Leased Asset' || sharedFields?.category === 'Sale') && (<Grid item md={4} style={{ display: 'flex', flexDirection: 'row', }} >
                                    <TextField
                                        fullWidth
                                        label="Vendor Name"
                                        value={asset.vendorName || ''}
                                        onChange={(e) => handleAssetChange(index, 'vendorName', e.target.value)}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '&.Mui-focused fieldset': {
                                                    borderColor: '#008080',
                                                },
                                            },
                                            '& .MuiInputLabel-root.Mui-focused': {
                                                color: '#008080',
                                            },
                                        }}
                                    />
                                </Grid>
                                )}
                            </Grid>
                            <Grid container spacing={2}>
                                {(sharedFields?.category === 'Treatment' || sharedFields?.category === 'Distribution') && (
                                    <Grid item md={4}>
                                    {errors[`asset_${index}_rating`] && (
                                        <div className="error-text">{errors[`asset_${index}_rating`]}</div>
                                    )}
                                    </Grid>
                                )}

                                {(sharedFields?.category === 'Treatment' || sharedFields?.category === 'Distribution') && (
                                    <Grid item md={4}>
                                    {errors[`asset_${index}_unitPrice`] && (
                                        <div className="error-text">{errors[`asset_${index}_unitPrice`]}</div>
                                    )}
                                    </Grid>
                                )}

                                <Grid item md={4}>
                                    {errors[`asset_${index}_cost`] && (
                                    <div className="error-text">{errors[`asset_${index}_cost`]}</div>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item md={4} sx={{ mt: 2, mb: 2 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
                                        <DatePicker
                                            label="Date of Purchase*"
                                            format="DD/MM/YYYY"
                                            required
                                            slotProps={
                                                { 
                                                    textField: 
                                                    { 
                                                        fullWidth: true, 
                                                        error: false, 
                                                        sx: {
                                                            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                borderColor: '#008080'
                                                            },
                                                            '& .MuiInputLabel-root.Mui-focused': {
                                                                color: '#008080'
                                                            }
                                                        }
                                                    },
                                                    day: {
                                                        sx: {
                                                            '&.Mui-selected': {
                                                                backgroundColor: '#008080 !important',
                                                                '&:hover': {
                                                                    backgroundColor: '#006666 !important'
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            name="purchaseDate"
                                            value={asset.purchaseDate ? dayjs(asset.purchaseDate) : null}
                                            onChange={(newValue) => handleAssetChange(index, 'purchaseDate', newValue)}
                                            maxDate={dayjs()}
                                        />
                                    </LocalizationProvider>
                                    {errors[`asset_${index}_purchaseDate`] && (
                                        <div className='error-text'>{errors[`asset_${index}_purchaseDate`]}</div>
                                    )}
                                </Grid>
                                {(sharedFields?.category === 'Leased Asset' || sharedFields?.category === 'Sale')  && (<Grid item md={4} sx={{ mt: 2, mb: 2 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
                                        <DatePicker
                                            label="End of Warranty Date"
                                            format="DD/MM/YYYY"
                                            disabled={!asset.purchaseDate}
                                            slotProps={{
                                                textField: {
                                                    fullWidth: true,
                                                    error: false,
                                                    sx: {
                                                        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: '#008080'
                                                        },
                                                        '& .MuiInputLabel-root.Mui-focused': {
                                                            color: '#008080'
                                                        }
                                                    },
                                                    day: {
                                                        sx: {
                                                            '&.Mui-selected': {
                                                                backgroundColor: '#008080 !important',
                                                                '&:hover': {
                                                                    backgroundColor: '#006666 !important'
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }}
                                            name="endOfWarrantyDate"
                                            value={asset.endOfWarrantyDate ? dayjs(asset.endOfWarrantyDate) : null}
                                            onChange={(newValue) => handleAssetChange(index, 'endOfWarrantyDate', newValue)}
                                            minDate={dayjs(asset.purchaseDate)}
                                        />
                                    </LocalizationProvider>
                                    {errors[`asset_${index}_endOfWarrantyDate`] && (
                                        <div className='error-text w3-margin-bottom'>
                                            {errors[`asset_${index}_endOfWarrantyDate`]}
                                        </div>
                                    )}
                                </Grid>)}
                                <Grid item md={4} sx={{ mt: 2, mb: 2 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
                                        <DatePicker
                                            label="Date of Installation*"
                                            format="DD/MM/YYYY"
                                            disabled={!asset.purchaseDate}
                                            required
                                            minDate={dayjs(asset.purchaseDate)}
                                            slotProps={{
                                                textField: {
                                                    fullWidth: true, error: false,
                                                    sx: {
                                                        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: '#008080'
                                                        },
                                                        '& .MuiInputLabel-root.Mui-focused': {
                                                            color: '#008080'
                                                        }
                                                    },
                                                    day: {
                                                        sx: {
                                                            '&.Mui-selected': {
                                                                backgroundColor: '#008080 !important',
                                                                '&:hover': {
                                                                    backgroundColor: '#006666 !important'
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }}
                                            name="installationDate"
                                            value={asset.installationDate ? dayjs(asset.installationDate) : null}
                                            onChange={(newValue) => handleAssetChange(index, 'installationDate', newValue)}
                                            maxDate={sharedFields?.category === "Sale" ? undefined : dayjs()}
                                        />
                                    </LocalizationProvider>
                                    {errors[`asset_${index}_installationDate`] && (
                                        <div className='error-text w3-margin-bottom'>
                                            {errors[`asset_${index}_installationDate`]}
                                        </div>
                                    )}
                                </Grid>
                                {(sharedFields?.category === 'Treatment' || sharedFields?.category === 'Distribution')  && (<Grid item md={4} sx={{ mt: 2, mb: 2 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
                                        <DatePicker
                                            label="Operation Start Date*"
                                            format="DD/MM/YYYY"
                                            required
                                            disabled={!asset.installationDate}
                                            minDate={dayjs(asset.installationDate)}
                                            slotProps={{
                                                textField: {
                                                    fullWidth: true, error: false, sx: {
                                                        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: '#008080'
                                                        },
                                                        '& .MuiInputLabel-root.Mui-focused': {
                                                            color: '#008080'
                                                        }
                                                    },
                                                    day: {
                                                        sx: {
                                                            '&.Mui-selected': {
                                                                backgroundColor: '#008080 !important',
                                                                '&:hover': {
                                                                    backgroundColor: '#006666 !important'
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }}
                                            name="operationStartDate"
                                            value={asset.operationStartDate ? dayjs(asset.operationStartDate) : null}
                                            onChange={(newValue) => handleAssetChange(index, 'operationStartDate', newValue)}
                                            maxDate={dayjs()}
                                        />
                                    </LocalizationProvider>
                                    {errors[`asset_${index}_operationStartDate`] && (
                                        <div className='error-text w3-margin-bottom'>
                                            {errors[`asset_${index}_operationStartDate`]}
                                        </div>
                                    )}
                                </Grid>)}
                            </Grid>
                            <Grid container spacing={2}>
                                {(sharedFields?.category === 'Treatment' || sharedFields?.category === 'Distribution')  && (<Grid item md={4} sx={{ mt: 2, mb: 2 }} style={{ marginTop: '0px'}}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
                                        <DatePicker
                                            label="Operation End Date"
                                            format="DD/MM/YYYY"
                                            // required
                                            disabled={!asset.operationStartDate}
                                            minDate={dayjs(asset.operationStartDate)}
                                            slotProps={{
                                                textField: {
                                                    fullWidth: true, error: false, sx: {
                                                        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: '#008080'
                                                        },
                                                        '& .MuiInputLabel-root.Mui-focused': {
                                                            color: '#008080'
                                                        }
                                                    },
                                                    day: {
                                                        sx: {
                                                            '&.Mui-selected': {
                                                                backgroundColor: '#008080 !important',
                                                                '&:hover': {
                                                                    backgroundColor: '#006666 !important'
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }}
                                            name="operationEndDate"
                                            value={asset.operationEndDate ? dayjs(asset.operationEndDate) : null}
                                            onChange={(newValue) => handleAssetChange(index, 'operationEndDate', newValue)}
                                            maxDate={dayjs()}
                                        />
                                    </LocalizationProvider>
                                    {errors[`asset_${index}_operationEndDate`] && (
                                        <div className='error-text'>
                                            {errors[`asset_${index}_operationEndDate`]}
                                        </div>
                                    )}
                                </Grid>)}
                                {(sharedFields?.category === 'Treatment' || sharedFields?.category === 'Distribution') && (<Grid item md={4} sx={{ mt: 2, mb: 2 }} style={{ marginTop: '0px'}}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
                                        <DatePicker
                                            label="End Of Life Date"
                                            format="DD/MM/YYYY"
                                            disabled={!asset.operationEndDate}
                                            minDate={dayjs(asset.operationEndDate)}
                                            slotProps={{
                                                textField: {
                                                    fullWidth: true, error: false, sx: {
                                                        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: '#008080'
                                                        },
                                                        '& .MuiInputLabel-root.Mui-focused': {
                                                            color: '#008080'
                                                        }
                                                    },
                                                    day: {
                                                        sx: {
                                                            '&.Mui-selected': {
                                                                backgroundColor: '#008080 !important',
                                                                '&:hover': {
                                                                    backgroundColor: '#006666 !important'
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }}
                                            name="endOfLifeDate"
                                            value={asset.endOfLifeDate ? dayjs(asset.endOfLifeDate) : null}
                                            onChange={(newValue) => handleAssetChange(index, 'endOfLifeDate', newValue)}
                                            maxDate={dayjs()}
                                        />
                                    </LocalizationProvider>
                                    {errors[`asset_${index}_endOfLifeDate`] && (
                                        <div className='error-text'>
                                            {errors[`asset_${index}_endOfLifeDate`]}
                                        </div>
                                    )}
                                </Grid>)}
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item md={12} sx={{ mt: sharedFields?.category === 'Treatment' || sharedFields?.category === 'Distribution' ? 0 : 2, mb: 2 }}>
                                    <TextField
                                        fullWidth
                                        value={asset.coordinates}
                                        label="Geo Tagging"
                                        placeholder='12.9716, 77.5946'
                                        name="coordinates"
                                        onChange={(e) => handleAssetChange(index, 'coordinates', e.target.value)}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => getCurrentLocation(index)}>
                                                        <MyLocationIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '&.Mui-focused fieldset': {
                                                    borderColor: '#008080',
                                                },
                                            },
                                            '& .MuiInputLabel-root.Mui-focused': {
                                                color: '#008080',
                                            },
                                        }}
                                        />
                                </Grid>
                            </Grid>
                            {errors[`asset_${index}_coordinates`] && (
                                <div style={{ marginTop: '-12px' }} className='error-text w3-margin-bottom'>
                                    {errors[`asset_${index}_coordinates`]}
                                </div>
                            )}
                            <Grid item md={12} style={{ display: 'flex', flexDirection: 'row', }} className='w3-margin-bottom'>
                                <TextField
                                    fullWidth
                                    required
                                    multiline
                                    rows={4}
                                    label="Particulars"
                                    value={asset.particulars}
                                    onChange={(e) => handleAssetChange(index, 'particulars', e.target.value)}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#008080',
                                            },
                                        },
                                        '& .MuiInputLabel-root.Mui-focused': {
                                            color: '#008080',
                                        },
                                    }}
                                />
                            </Grid>
                            {errors[`asset_${index}_particulars`] && (
                                <div style={{ marginTop: '-12px' }} className='error-text w3-margin-bottom'>
                                    {errors[`asset_${index}_particulars`]}
                                </div>
                            )}
                            <Grid container item md={12} className='w3-margin-bottom'>
                                <Grid item md={9} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Grid>
                                        <FormGroup>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                    sx={checkboxStyle}
                                                    checked={asset.inactive}
                                                    onChange={(e) => handleInactiveStatus(index, e)}
                                                    />
                                                }
                                                label="Inactive"
                                            />
                                        </FormGroup>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container item md={12} className='w3-margin-bottom'>
                                <label htmlFor={`logo-file-${index}`}>
                                    <input
                                        style={{ display: 'none' }}
                                        required
                                        id={`logo-file-${index}`}
                                        name="logoFile"
                                        type="file"
                                        accept="image/jpeg, image/png, image/gif"
                                        onChange={(e) => handleImageUpload(index, e)}
                                        multiple
                                    />

                                    <div style={{ display: 'flex' }}>
                                        <div>
                                            <Button
                                                sx={buttonStyles.outlined}
                                                className="w3-margin-top"
                                                variant="outlined"
                                                size="medium"
                                                component="span">
                                                Upload Images
                                            </Button>
                                        </div>
                                    </div>
                                </label>
                            </Grid>
                            <Grid container item md={12} className='w3-margin-bottom'>
                                {asset.images.map((img) => (
                                    <div key={img.uid} style={{ position: 'relative', marginRight: 8, marginBottom: 8 }}>
                                        <img
                                            src={img.url}
                                            alt={img.name}
                                            width="150px" 
                                            style={{ padding: '5px' }}
                                        />
                                    <IconButton
                                        aria-label="delete"
                                        onClick={() => handleImageDelete(index, img.uid)}
                                        style={{ position: 'absolute', top: '5px', right: '5px' }}
                                    >
                                    <DeleteIcon fontSize="small" />
                                    </IconButton>
                                    </div>
                                ))}
                            </Grid>
                            </Paper>
                            </>))}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={12} style={{ display: 'flex', flexDirection: 'row' }}>
                        <Grid item md={6} style={{ display: 'flex', justifyContent: 'flex-start', paddingLeft: '16px' }} className='w3-margin-bottom'>
                                <Button 
                                    onClick={addAsset} 
                                    variant="outlined"
                                    style={{ fontWeight: 'bold', borderColor: '#008080', color: '#008080'}}>
                                        + Add Asset
                                </Button>
                            </Grid>
                        <Grid item md={6} style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '16px' }} className='w3-margin-bottom'>
                            { id && (<Button
                                variant="outlined"
                                color="error"
                                onClick={() => triggerDelete()}
                                >
                                Delete
                                </Button>)}

                            <Button
                                variant="outlined"
                                sx={{ marginLeft: '10px', ...buttonStyles.outlined }}
                                onClick={() => clientAssetQueryParams ? navigate(`/client/${client_id}/client-assets/${clientAssetTabId ? clientAssetTabId : tabId}?${clientAssetQueryParams?.toString()}`) : navigate(`/client/${client_id}/client-assets/${clientAssetTabId ? clientAssetTabId : tabId}`)}
                            >
                                Cancel</Button>
                                <Button
                                    // disabled={disableButton}
                                    variant="contained"
                                    onClick={handleSubmit}
                                    sx={{ marginLeft: '10px', ...buttonStyles.contained }}
                                    disabled={disableButton}
                                >
                                    Submit</Button>
                        </Grid>
                    </Grid>
                </Grid>
                {alertMessage ?
                    (
                        <AlertDialog
                            handleClose={handleCloseDialog}
                            message={alertMessage}
                            type={msgType}
                            handleDialogClose={() => setAlertMessage(null)}
                        />
                    )
                    : null
                }
                {showConfirmDialog
                        ? (
                            <ConfirmDialog
                                handleCancel={() => {
                                    setShowConfirmDialog(false)
                                }}
                                handleOk={handleDeleteClientAsset}
                                message={'⚠️ This action will delete all the assets under this facility and category, Are you sure to continue...?'}
                            />
                        ) : null}
                {showConfirmUploadDialog
                    ? (
                        <ConfirmDialog
                            handleCancel={() => {
                                setShowConfirmUploadDialog(false)
                            }}
                            handleOk={handleConfirmUpload}
                            message={'Are you sure to Upload Image?'}
                        />
                    ) : null}   
                    {clickSubmitButton && <Loader open={clickSubmitButton} msg="Please wait...!"/>}     
            </Grid>
            <Snackbar
                open={!!geoError}
                autoHideDuration={5000}
                onClose={() => setGeoError('')}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                <Alert onClose={() => setGeoError('')} severity="error" sx={{ width: '100%' }}>
                    {geoError}
                </Alert>
            </Snackbar>
        </Paper>
    )
}